import React from "react";

const CustomIcon = (props) => (
  <img
    src={props.src}
    alt="icon"
    style={{ width: 24, height: 24, ...props.className }}
  />
);

export default CustomIcon;



// WEBPACK FOOTER //
// ./src/components/CustomIcon.js